<script lang="ts">
    import PageHeader from '~/components/jet/header/PageHeader.svelte';
    import ArtistDetailHeaderLockup from '~/components/jet/header/ArtistDetailHeaderLockup.svelte';
    import ContainerDetailHeader from '~/components/jet/header/ContainerDetailHeader.svelte';
    import UberDetailHeader from '~/components/jet/header/UberDetailHeader.svelte';
    import WorkDetailHeader from '~/components/jet/header/WorkDetailHeader.svelte';
    import Section from '~/jet/components/Section.svelte';
    import type { Page } from '~/jet/models';
    import InfiniteScroll from '@amp/web-app-components/src/components/InfiniteScroll/InfiniteScroll.svelte';
    import { paginationStore } from '~/stores/pagination';
    import { getJetPerform } from '~/jet';
    import { makeInvalidationAction } from '@jet-app/music-classical/action-model/InvalidationAction';

    export let page: Page;

    let isLibraryTracksPage = page.kind === 'libraryTracksPage';

    const HEADER_COMPONENT_MAPPING = {
        album: ContainerDetailHeader,
        artist: ArtistDetailHeaderLockup,
        genre: ArtistDetailHeaderLockup,
        instrument: ArtistDetailHeaderLockup,
        multiRoom: UberDetailHeader,
        period: ArtistDetailHeaderLockup,
        playlist: ContainerDetailHeader,
        recording: ContainerDetailHeader,
        work: WorkDetailHeader,
    };

    const perform = getJetPerform();

    $: hasNextPage = !!page.nextIntent;
    $: isLoading = $paginationStore.isLoadingNextPage;
    $: headerComponent = headerMapping[page.screenType] ?? PageHeader;
    $: headerMapping = HEADER_COMPONENT_MAPPING;

    async function loadNextPage(): Promise<void> {
        if (hasNextPage) {
            perform(makeInvalidationAction({ kind: 'nextPage' }));
        }
    }
</script>

<div
    class="default-page-container"
    class:is-library-tracks={isLibraryTracksPage}
    data-testid="default-page"
>
    <svelte:component this={headerComponent} header={page.header} />

    <!-- rdar://136608840 ([Classical on Web] Add support for additional lockup types in shelves) -->
    {#each page.sections?.filter(Boolean) as section}
        <Section {section} />
    {/each}

    {#if hasNextPage}
        <!-- Not passing in items to the InfiniteScroll component as we don't want it to loop over
    items and render them, but we want to use it's functionality of triggering an action
    when in view and loading the spinner without duplicating that logic. -->
        <InfiniteScroll
            items={[]}
            hasMore={hasNextPage}
            {isLoading}
            loadMore={loadNextPage}
        />
    {/if}
</div>

<style lang="scss">
    .default-page-container {
        background-color: initial;

        // Add spacing between artist / work header and section shelves
        :global(.work-header-container + .section),
        :global(.artist-header-container + .section) {
            margin-top: 15px;
        }
    }

    .is-library-tracks {
        :global(.header-nav) {
            padding-top: 12px;
        }

        :global(.header-nav__heading) {
            font: var(--title-2-emphasized-serif);
        }
    }
</style>
